var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEnrolledStudents(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9",
    "data-name": "Rectangle 9",
    width: 20,
    height: 20,
    transform: "translate(286 263)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_1",
    "data-name": "Mask Group 1",
    transform: "translate(-286 -263)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "persons-in-a-class-svgrepo-com",
    transform: "translate(286.018 263)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M16.4,9.538h2.84a3.367,3.367,0,0,1,1.177-2h.009a3.144,3.144,0,0,0,1.782-.61c.076-.056.15-.117.222-.179a5.289,5.289,0,0,0,1.448-3.911.87.87,0,0,0-.834-.9.838.838,0,0,0-.9.835A3.585,3.585,0,0,1,21.2,5.524a1.336,1.336,0,0,1-.383.2l-.013,0A1.961,1.961,0,0,0,19.553,5.2H15.261a1.6,1.6,0,0,0-1.427,1.658A3.441,3.441,0,0,1,16.4,9.538Z",
    transform: "translate(-8.088 -1.132)",
    fill: "#136ad0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1",
    "data-name": "Ellipse 1",
    cx: 2.06,
    cy: 2.018,
    rx: 2.06,
    ry: 2.018,
    transform: "translate(7.258)",
    fill: "#136ad0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M10.049,22.917c0-1.566-.675-2.227-1.611-2.227H6.268a2.385,2.385,0,1,0-2.789-2.355A2.4,2.4,0,0,0,5.548,20.69H3.376a1.952,1.952,0,0,0-1.7,2.04V25.9h8.371Z",
    transform: "translate(-0.997 -9.307)",
    fill: "#136ad0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M26.5,18.336a2.4,2.4,0,0,0,2.068,2.355H26.392a1.918,1.918,0,0,0-1.654,2.04V25.9h8.306V22.92c0-1.548-.65-2.2-1.567-2.215-.013,0-.012-.013-.023-.013H29.283A2.385,2.385,0,1,0,26.5,18.336Z",
    transform: "translate(-14.449 -9.308)",
    fill: "#136ad0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10",
    "data-name": "Rectangle 10",
    width: 19.963,
    height: 2.046,
    transform: "translate(0 17.954)",
    fill: "#136ad0"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnrolledStudents);
export default __webpack_public_path__ + "static/media/enrolled-students.d998939d02d735ce7f24fae505c27f1a.svg";
export { ForwardRef as ReactComponent };